import React from "react";

// type 2: ẩn partner đã bị xóa
const getListPartnerName = (promotion_set_id, list_partner, type = 1) => {
  let list_partner_id;
  if (type === 1) {
    list_partner_id = list_partner.filter(
      (item) => +item.promotion_set_id === promotion_set_id
    );
  } else {
    list_partner_id = list_partner.filter(
      (item) => +item.promotion_set_id === promotion_set_id && item.action !== 2
    );
  }

  if (list_partner_id.length > 0) {
    return list_partner_id
      .map((item) => item.last_name + " " + item.first_name)
      .join(", ");
  }

  return "なし";
};

// type 2: ẩn partner đã bị xóa
const ListPartner = ({ entry, list, type }) => {
  return (
    <div className="mt-2">
      {entry.promotion_sets.map((item) => {
          return (
            <div key={item.id} className="my-2 fw-600 fs-13">
              { entry?.split_flg == 1 &&
              <div className="bg-violet px-2 py-1 fs-sm-12 mb-sm-1-px">
                {item.name}
              </div>}
              { entry?.partner_flg == 1 &&
              <div className="bg-pink px-2 py-1 py-1 fs-sm-9">
                同行者：{getListPartnerName(item.id, list, type)}
              </div>}
            </div>
          );
      })}
    </div>
  );
};

export { ListPartner, getListPartnerName };
